'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
const ThankYouDialog = dynamic(() => import('@/components/ThankYouDialog'), {
  ssr: false
});
function WorldThankYouDialog() {
  const $ = _c(2);
  const {
    roomData
  } = useCheckEnterRoomContext();
  let t0;
  if ($[0] !== roomData.owner.head_icon_url) {
    t0 = <ThankYouDialog avatarSrc={roomData.owner.head_icon_url} />;
    $[0] = roomData.owner.head_icon_url;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default WorldThankYouDialog;